import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-input',
  templateUrl: 'novatiq-form-input.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NovatiqFormInputComponent),
      multi: true
    }
  ],
  imports: [FormsModule]
})
export class NovatiqFormInputComponent implements ControlValueAccessor {
  @Input() cssClass = '';
  @Input() id: string;
  @Input() isReadOnly = false;
  @Input() isDisabled = false;
  @Input() name: string;
  @Input() placeholder = '';
  @Input() type = 'text';
  @Input() defaultValue: string;
  @Input() maxlength = 0;
  @Input() minlength = 0;

  private value: unknown = '';

  get modelValue(): unknown {
    return this.value;
  }

  set modelValue(v: unknown) {
    if (v !== this.value) {
      this.value = v;
      this.onChange(v);
    }
  }

  onChange = (_: unknown) => _;

  onTouched = (_: unknown) => _;

  registerOnChange(fn: (_: unknown) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  writeValue(value: unknown) {
    this.value = value;
    this.onChange(value);
  }
}
